import { GET, POST } from '@/utils/request'
import Url from './url'

export const cities = async (params: any) => {
  return await GET({
    url: Url.cities,
    params,
    showError: false
  })
//   const res = Request({ url: Url.cities, method: 'GET', data })
//   return await res
}
export const cityStatus = async (params: any) => {
  return await GET({
    url: Url.cityStatus,
    params,
    showError: false
  })
//   const res = Request({
//     url: Url.cityStatus,
//     method: 'GET',
//     params
//   })
//   return await res
}
export const popupOfCity = async (params: any) => {
  return await POST({
    url: Url.popupOfCity,
    params: params,
    showError: false,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
//   const res = Request({
//     url: Url.popupOfCity,
//     method: 'POST',
//     params,
//     headers: {
//       'Content-Type': 'application/x-www-form-urlencoded'
//     },
//     withCredentials: true
//   })
//   return await res
}

export const submitCity = async (data: any) => {
  return await POST({
    url: Url.submitCity,
    data: data,
    showError: false

  })
//   const res = Request({
//     url: Url.submitCity,
//     method: 'POST',
//     data,
//     headers: {
//       'Content-Type': 'application/json'
//     },
//     withCredentials: true
//   })
//   return await res
}
